import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class CollaboratorAdded extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'CollaboratorAdded';

    public constructor(public userId: string, public name: string) {
        super(CollaboratorAdded.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CollaboratorAdded): void => {
    if (action.userId != null) {
        state.collaborators.push({
            userId: action.userId,
            name: action.name
        });
    }
};

//@ts-ignore
registerReducer(CollaboratorAdded.ACTION_TYPE, reducer);